var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{class:_vm.classes},[_c('img',{staticClass:"ma-auto d-block",style:('height :' + _vm.height  + 'px'),attrs:{"src":require("@/assets/img/png/files/loading.gif"),"alt":"Qawaem"}}),(!_vm.hideText)?_c('p',{staticClass:"text-center my-3"},[_vm._v(_vm._s(_vm.$t("loading data")))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }